















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { IEntity } from '@signing-page/entity/types/entity';
import type { IUser } from '@signing-page/users/types/user';

@Component
export default class ESignConsent extends Vue {
  @Prop() entity!: IEntity;
  @Prop() sender!: IUser;

  get senderEmail(): string {
    return this.entity.email || this.sender.email;
  }
}
